import { writable } from 'svelte/store';

/**
 * Module store (not component context): PeekTray is passed through named
 * slots, so it is not a context descendant of DeviceViewStateWrapper.
 */
export const peekTrayOverlayOpen = writable(false);

export const closePeekTrayOverlay = () => peekTrayOverlayOpen.set(false);
